var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "swiper-container" }, [
        _c(
          "div",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.currentList, function(item, i) {
            return _c(
              "ul",
              {
                key: i,
                ref: "ul",
                refInFor: true,
                staticClass: "swiper-slide"
              },
              _vm._l(item, function(k, j) {
                return _c(
                  "li",
                  {
                    key: j,
                    on: {
                      click: function($event) {
                        return _vm.setCurrent(j, k.sendDate)
                      }
                    }
                  },
                  [
                    _c("p", [_vm._v(_vm._s(k.week))]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { display: "none" } }, [
                      _vm._v(_vm._s(k.sendDate))
                    ]),
                    _vm._v(" "),
                    k.now
                      ? _c("i", { staticClass: "iconfont icon-jin" })
                      : _c(
                          "span",
                          {
                            class: [
                              { active: _vm.nowDateStr == k.sendDate },
                              { checked: _vm.currentIndex == j }
                            ]
                          },
                          [_vm._v(_vm._s(k.showDate))]
                        ),
                    _vm._v(" "),
                    k.list && k.list.length > 0 && _vm.nowDateStr != k.sendDate
                      ? _c("span", {
                          class: { dot: _vm.nowDateStr != k.sendDate }
                        })
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cateory", style: { left: _vm.cateLeft + "px" } },
          [_c("i")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lession-list" }, [
        !_vm.newCalendarListArr
          ? _c("div", { staticClass: "nodata" }, [
              _c("p", [_vm._v("当天暂无直播")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.newCalendarListArr && _vm.newCalendarListArr.length > 0
          ? _c(
              "ul",
              [
                _vm._l(_vm.newCalendarListArr, function(item, i) {
                  return _c("div", { key: i, staticClass: "template-div" }, [
                    i == 0 && !_vm.isShow
                      ? _c(
                          "li",
                          {
                            on: {
                              click: function($event) {
                                return _vm.go_zhibo(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "left-div" }, [
                              _c("p", { staticClass: "time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTime(Number(item.start_time) * 1000)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              Number(item.start_time) - 3600 >
                              new Date().getTime() / 1000
                                ? _c("p", { staticClass: "tagtip" }, [
                                    _vm._v("未开始")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nowDateStr == _vm.dateStr &&
                              Number(item.start_time) - 3600 <
                                new Date().getTime() / 1000 &&
                              Number(item.start_time) >
                                new Date().getTime() / 1000
                                ? _c("p", { staticClass: "tag" }, [
                                    _vm._v("即将开始")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !item.noLivePush &&
                              _vm.nowDateStr == _vm.dateStr &&
                              Number(item.start_time) <
                                new Date().getTime() / 1000 &&
                              new Date().getTime() / 1000 <
                                Number(item.end_time) + 9000
                                ? _c("p", { staticClass: "tag" }, [
                                    _vm._v("直播中")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.noLivePush && item.offline_code
                                ? _c("p", { staticClass: "tagtip" }, [
                                    _vm._v("看回放")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.noLivePush && item.offline_code == ""
                                ? _c("p", { staticClass: "tagtip" }, [
                                    _vm._v("已结束")
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "placeholder" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "right-div" }, [
                              _c("p", { staticClass: "lesson-name" }, [
                                _vm._v(_vm._s(item.lesson_name))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "package-name" }, [
                                _vm._v(_vm._s(item.package_name))
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShow
                      ? _c(
                          "li",
                          {
                            on: {
                              click: function($event) {
                                return _vm.go_zhibo(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "left-div" }, [
                              _c("p", { staticClass: "time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTime(Number(item.start_time) * 1000)
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              Number(item.start_time) - 3600 >
                              new Date().getTime() / 1000
                                ? _c("p", { staticClass: "tagtip" }, [
                                    _vm._v("未开始")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nowDateStr == _vm.dateStr &&
                              Number(item.start_time) - 3600 <
                                new Date().getTime() / 1000 &&
                              Number(item.start_time) >
                                new Date().getTime() / 1000
                                ? _c("p", { staticClass: "tag" }, [
                                    _vm._v("即将开始")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !item.noLivePush &&
                              _vm.nowDateStr == _vm.dateStr &&
                              Number(item.start_time) <
                                new Date().getTime() / 1000 &&
                              new Date().getTime() / 1000 <
                                Number(item.end_time) + 9000
                                ? _c("p", { staticClass: "tag" }, [
                                    _vm._v("直播中")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.noLivePush && item.offline_code
                                ? _c("p", { staticClass: "tagtip" }, [
                                    _vm._v("看回放")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.noLivePush && item.offline_code == ""
                                ? _c("p", { staticClass: "tagtip" }, [
                                    _vm._v("已结束")
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "placeholder" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "right-div" }, [
                              _c("p", { staticClass: "lesson-name" }, [
                                _vm._v(_vm._s(item.lesson_name))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "package-name" }, [
                                _vm._v(_vm._s(item.package_name))
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                }),
                _vm._v(" "),
                _vm.newCalendarListArr && _vm.newCalendarListArr.length > 1
                  ? _c(
                      "p",
                      {
                        staticClass: "operate-btn",
                        on: {
                          click: function($event) {
                            return _vm.showAll()
                          }
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收起" : "展开更多")),
                        _c("i", {
                          staticClass: "updown",
                          class: [
                            { "el-icon-arrow-down": !_vm.isShow },
                            { "el-icon-arrow-up": _vm.isShow }
                          ]
                        })
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + '"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.scheme +
                              "?type=1&orderSn=" +
                              _vm.sn +
                              "&owner=" +
                              this.$route.query.owner +
                              "&channel=" +
                              this.$route.query.channel +
                              "&orgn=" +
                              this.$route.query.orgn
                          },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 1 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12542751", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12542751","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/loop.vue
// module id = null
// module chunks = 